import React, { lazy, Suspense } from 'react';
import type { FC } from 'react';
import styled from 'styled-components';

import HeaderMenu, {
  HeaderMenuCategory,
  NestedMenu,
} from '@lt/components/components/HeaderMenu';

import { isSSR } from 'src/helpers/ssr';
import HeaderFeedback from '../../HeaderFeedback';
import HeaderWishlist from '../../HeaderWishlist';

import type { IHeaderMenu } from '../types';

const HeaderAuth = lazy(
  () =>
    import(
      /* webpackChunkName: "HeaderAuth" */ 'src/components/Header/components/HeaderAuth'
    ),
);

const DesktopMenu: FC<IHeaderMenu> = ({
  services,
  help,
  className,
  isCollapsed,
  showAuthorizationBlock = true,
  showWishlist = true,
  showFeedback,
}) => (
  <StyledHeaderMenu className={className} isCompact={isCollapsed}>
    {/* https://leveltravel.atlassian.net/browse/LT-31772 */}
    {showFeedback && <HeaderFeedback isCompact={isCollapsed} />}
    {services && services.items && services.items.length !== 0 && (
      <Services isCompact={isCollapsed} {...services} />
    )}
    {showWishlist && <HeaderWishlist isCompact={isCollapsed} />}
    {help && help.items && help.items.length !== 0 && (
      <Help isCompact={isCollapsed} {...help} />
    )}
    {showAuthorizationBlock && !isSSR && (
      <Suspense fallback={<div />}>
        <HeaderAuth isCompact={isCollapsed} />
      </Suspense>
    )}
  </StyledHeaderMenu>
);

const StyledHeaderMenu = styled(HeaderMenu)<{
  isCompact?: boolean;
}>`
  ${({ isCompact }) => isCompact && 'padding-top: 20px;'}
`;

const Services = styled(HeaderMenuCategory)<{ isCompact?: boolean }>`
  &:hover {
    background-color: #292929;
    border-radius: 3px 3px 0 0;
    color: #fff;
    svg {
      stroke: #fff;
    }
  }

  ${NestedMenu} {
    text-align: right;

    ${({ isCompact }) =>
      !isCompact &&
      `
        right: inherit;
        right: 0;
        left: auto;
      `}
  }
`;

const Help = styled(HeaderMenuCategory)`
  &:hover {
    background-color: #292929;
    border-radius: 3px 3px 0 0;
    color: #fff;
    svg {
      stroke: #fff;
    }
  }
  ${NestedMenu} {
    text-align: right;
  }
`;

export default DesktopMenu;
